	export enum ClaimBox1PlanTypeEnum {
		MediCare = 1,
		MedicAid = 2,
		TriCare = 3,
		Champva = 4,
		GrpupHealthPlan = 5,
		FecaBlkLung = 6,
		Other = 7
	}
